/* import __COLOCATED_TEMPLATE__ from './lsg-sort.hbs'; */
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { ICON_SORTS } from "../../constants/lsg";

/**
 * This is a sort component for ascending and descending sorts
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'span',
  classNames: ['LSG-c-sort'],
  classNameBindings: [
    'isDisabled:LSG-c-sort--disabled',
    '_isAscending:LSG-c-sort--ascending'
  ],

  /**
   * Register services
   */
  errorTracker: service('error-tracker'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /**
   * The function that will be called when the sort is toggled.
   *
   * @param {Function}
   */
  onSortChanged: function(iconSort) {
    throw new Error('define sort changed function');
  },

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /**
   * The direction of the sort.
   *
   * @param {String} iconSort       of type ICON_SORTS.*
   */
  iconSort: ICON_SORTS.SORT_DESCENDING,

  /**
   * When this is 'disabled' that just means the sort isn't 'active' looking in the UI, but would still be clickable.
   *
   * @param {Boolean}
   */
  isDisabled: false,

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Boolean}    True when we're in the ascending mode.
   */
  _isAscending: computed('isDisabled', 'iconSort', function() {
    if (this.get('isDisabled')) {
      return false;
    }

    return this.get('iconSort') === ICON_SORTS.SORT_ASCENDING;
  }),

  /**
   * @inheritDoc
   */
  actions: {

    /**
     * Called when button is clicked to toggle the icon sort.
     */
    onToggleIconSort: function() {
      let newSort = this.get('iconSort') === ICON_SORTS.SORT_ASCENDING ?
        ICON_SORTS.SORT_DESCENDING :
        ICON_SORTS.SORT_ASCENDING;

      this.get('onSortChanged')(newSort);
    }
  }
});
